function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 21.998,
  y: 22,
  width: 4,
  height: 22,
  transform: "rotate(-180 21.998 22)",
  fill: "#7ED600"
});
var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 17.998,
  y: 22,
  width: 3.6,
  height: 22,
  transform: "rotate(-180 17.998 22)",
  fill: "#B1E666"
});
var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 14.3965,
  y: 22,
  width: 3.6,
  height: 22,
  transform: "rotate(-180 14.3965 22)",
  fill: "#CBEF99"
});
var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 10.7988,
  y: 22,
  width: 3.6,
  height: 22,
  transform: "rotate(-180 10.7988 22)",
  fill: "#F1F3F9"
});
var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 7.19727,
  y: 22,
  width: 3.6,
  height: 22,
  transform: "rotate(-180 7.19727 22)",
  fill: "#E1E6EF"
});
var _ref7 = /*#__PURE__*/React.createElement("rect", {
  x: 3.59961,
  y: 22,
  width: 3.6,
  height: 22,
  transform: "rotate(-180 3.59961 22)",
  fill: "#CBD2E1"
});
function SvgColorScale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorScale);
export default __webpack_public_path__ + "static/media/colorScale.39734ae13254fcbb547879e4bb327037.svg";
export { ForwardRef as ReactComponent };